import { render, staticRenderFns } from "./disponibilidade.vue?vue&type=template&id=40ba96f8&"
import script from "./disponibilidade.vue?vue&type=script&lang=js&"
export * from "./disponibilidade.vue?vue&type=script&lang=js&"
import style0 from "./disponibilidade.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports